import { AuthUser } from '@app/account/account-api.model';
import { LearningMetric } from '@app/orgs/services/orgs.model';
import { Option } from '@app/shared/components/select/select.component';

export const getMonthlyActivityDropdownOptions = (
  i18n: { [key: string]: string },
  authUser: AuthUser
): Option[] => {
  const dropdownOptions: Option[] = [
    {
      id: LearningMetric.ItemsCompleted,
      title: i18n.OrgSettings_MonthlyActivityTypes_ItemsCompleted,
    },
    {
      id: LearningMetric.ItemsViewed,
      title: i18n.OrgSettings_MonthlyActivityTypes_ItemsViewed,
    },
    {
      id: LearningMetric.LearningDuration,
      title: i18n.OrgSettings_MonthlyActivityTypes_LearningDuration,
    },
  ];
  const pointsDropdownOption: Option = {
    id: LearningMetric.PointsEarned,
    title: i18n.OrgSettings_MonthlyActivityTypes_PointsEarned,
  };

  if (!authUser.orgInfo[0]?.settings.pointsDecommission) {
    dropdownOptions.splice(2, 0, pointsDropdownOption);
  }

  return dropdownOptions;
};

/** Scrolls ngbTypeahead container to active list item when using up and down arrows */
// linter fix - use any (keyboardEvent doesn't have nextElementSibling)
// it's likely this doesn't work anymore since we got rid of jquery!
// TODO: Look into
export const scrollToElement = (event: any): void => {
  const arrowUp = event.key === 'ArrowUp';
  const arrowDown = event.key === 'ArrowDown';
  if (arrowUp || arrowDown) {
    if (event.target.nextElementSibling?.nodeName === 'NGB-TYPEAHEAD-WINDOW') {
      const oldActiveDropdownEle =
        event.target.nextElementSibling.querySelector('.active');
      if (oldActiveDropdownEle) {
        let activeDropdownEle = arrowDown
          ? oldActiveDropdownEle.nextElementSibling
          : oldActiveDropdownEle.previousElementSibling;
        if (!activeDropdownEle) {
          const allDropdownElems =
            event.target.nextElementSibling.querySelectorAll('.dropdown-item');
          activeDropdownEle = arrowUp
            ? allDropdownElems[allDropdownElems.length - 1]
            : allDropdownElems[0];
          // SANITY CHECK: Bail if element is *still* not defined.
          if (!activeDropdownEle) {
            return;
          }
        }
        if (
          !isElementInViewport(activeDropdownEle, event.target) &&
          arrowDown
        ) {
          activeDropdownEle.scrollIntoView(false);
        }
        if (!isElementInViewport(activeDropdownEle, event.target) && arrowUp) {
          activeDropdownEle.scrollIntoView(true);
        }
      }
    }
  }
};

const isElementInViewport = (el, inputElem) => {
  const rect = el.getBoundingClientRect();
  const rectElem = inputElem.getBoundingClientRect();
  return (
    rect.top >= rectElem.bottom &&
    rect.left >= 0 &&
    rect.bottom <= rectElem.bottom + rect.offsetHeight &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};
